import React from 'react';

export default function ContentCard({ className, title, children, buttons }: { className?: string, title?: string, children?: React.ReactNode, buttons?: React.ReactNode }) {
    return (
        <div className={`card m-4 bg-neutral-100 dark:bg-neutral-900 shadow-xl ${className}`}>
            <div className="card-body">
                {title && <h2 className="card-title">{title}</h2>}
                {children && children}
                {buttons && 
                <div className="card-actions justify-end">
                    {buttons}
                </div>
                }
            </div>
        </div>
    )
}